import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  FormControl,
  FormLabel,
  Icon,
  IconButton,
  InputGroup,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import { Stack } from '@chakra-ui/layout';
import { useForm } from 'react-hook-form';
import { FiCheck, FiPlus, FiTrash } from 'react-icons/all';
import { FiChevronLeft, FiEdit2, FiX } from 'react-icons/fi';
import InputMask from 'react-input-mask';
import { Heading, Input, Select, Table } from '~/components';
import api from '~/utils/api';
import { queryClient } from '~/utils/react-query';
import { SelectItem } from '~/types';
import { useSinistersIssuer } from '~/hooks/useSinisters/useSinisters';
import apiSinister from '~/utils/apiSinister';
import { SinistersIssuers } from '~/types/sinisters';
import { useStates } from '~/hooks';

export const SinistersNewIssuerForm: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef(null);
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    setError,
    formState,
    clearErrors,
    control,
  } = useForm();
  const { errors } = formState;
  const [isEdit, setEdit] = useState<boolean[]>([]);
  const [empresa, setEmpresa] = useState<string>('');
  const [cnpj, setCnpj] = useState<string>('');
  const [endereco, setEndereco] = useState<string>('');
  const [numero, setNumero] = useState<string>('');
  const [complemento, setComplemento] = useState<string>('');
  const [bairro, setBairro] = useState<string>('');
  const [cidade, setCidade] = useState<string>('');
  const [estado, setEstado] = useState<string>('');
  const [cep, setCEP] = useState<string>('');
  const [titular, setTitular] = useState<string>('');
  const [banco, setBanco] = useState<string>('');
  const [codigo_banco, setCodigoBanco] = useState<string>('');
  const [agencia, setAgencia] = useState<string>('');
  const [conta, setConta] = useState<string>('');

  const [empresaEdit, setEmpresaEdit] = useState<SelectItem[]>([]);
  const [cnpjEdit, setCnpjEdit] = useState<SelectItem[]>([]);
  const [isFetching, setFetching] = useState(false);
  const toast = useToast();
  const {
    data: issuer,
    isLoading: isIssuerLoading,
    refetch,
  } = useSinistersIssuer();
  const { data: state, isLoading: isStatesLoading } = useStates();

  const handleOpen = () => {
    onOpen();
  };

  const handleClose = () => {
    clearErrors();
    onClose();
  };

  async function handleCreate() {
    clearErrors();

    (!empresa || !empresa?.trim().length) &&
      setError('empresa', {
        type: 'required',
        message: 'Informe o nome da empresa',
      });
    empresa.length > 128 &&
      setError('empresa', {
        type: 'maxLength',
        message: 'Nome da empresa com mais de 128 caracteres',
      });

    !cnpj &&
      setError('cnpj', {
        type: 'required',
        message: 'Informe o cnpj',
      });
    cnpj &&
      cnpj!.match(/\d/g)!.join('').length !== 14 &&
      setError('cnpj', {
        type: 'minLength',
        message: 'CNPJ está incorreto',
      });

    (!endereco || !endereco?.trim().length) &&
      setError('endereco', {
        type: 'required',
        message: 'Informe o endereço',
      });
    endereco.length > 255 &&
      setError('endereco', {
        type: 'maxLength',
        message: 'Endereço com mais de 255 caracteres',
      });

    (!numero || !numero?.trim().length) &&
      setError('numero', {
        type: 'required',
        message: 'Informe o número',
      });
    numero.length > 10 &&
      setError('numero', {
        type: 'maxLength',
        message: 'Número com mais de 10 caracteres',
      });

    (!complemento || !complemento?.trim().length) &&
      setError('complemento', {
        type: 'required',
        message: 'Informe o complemento',
      });
    complemento.length > 128 &&
      setError('complemento', {
        type: 'maxLength',
        message: 'Complemento com mais de 128 caracteres',
      });

    (!bairro || !bairro?.trim().length) &&
      setError('bairro', {
        type: 'required',
        message: 'Informe o bairro',
      });
    bairro.length > 128 &&
      setError('bairro', {
        type: 'maxLength',
        message: 'Bairro com mais de 128 caracteres',
      });

    (!cidade || !cidade?.trim().length) &&
      setError('cidade', {
        type: 'required',
        message: 'Informe a cidade',
      });
    cidade.length > 128 &&
      setError('cidade', {
        type: 'maxLength',
        message: 'Cidade com mais de 128 caracteres',
      });

    !estado &&
      setError('estado', {
        type: 'required',
        message: 'Selecione o estado',
      });

    (!cep || !cep?.trim().length) &&
      setError('cep', {
        type: 'required',
        message: 'Informe o CEP',
      });
    cep &&
      cep!.match(/\d/g)!.join('').length !== 8 &&
      setError('cep', {
        type: 'maxLength',
        message: 'CEP inválido',
      });

    (!titular || !titular?.trim().length) &&
      setError('titular', {
        type: 'required',
        message: 'Informe o titular',
      });
    titular.length > 255 &&
      setError('titular', {
        type: 'maxLength',
        message: 'Titular com mais de 255 caracteres',
      });

    (!banco || !banco?.trim().length) &&
      setError('banco', {
        type: 'required',
        message: 'Informe o banco',
      });
    banco.length > 255 &&
      setError('banco', {
        type: 'maxLength',
        message: 'Banco com mais de 255 caracteres',
      });

    (!codigo_banco || !codigo_banco?.trim().length) &&
      setError('codigo_banco', {
        type: 'required',
        message: 'Informe o código do banco',
      });
    codigo_banco.length > 20 &&
      setError('codigo_banco', {
        type: 'maxLength',
        message: 'Código com mais de 20 caracteres',
      });

    (!agencia || !agencia?.trim().length) &&
      setError('agencia', {
        type: 'required',
        message: 'Informe a agência',
      });
    agencia.length > 20 &&
      setError('agencia', {
        type: 'maxLength',
        message: 'Agência com mais de 20 caracteres',
      });

    (!conta || !conta?.trim().length) &&
      setError('conta', {
        type: 'required',
        message: 'Informe a conta',
      });
    conta.length > 20 &&
      setError('conta', {
        type: 'maxLength',
        message: 'Conta com mais de 20 caracteres',
      });

    const { _formState } = control;
    if (!_formState.isValid) return;

    const form = {
      nome: empresa?.trim(),
      cnpj: cnpj!.match(/\d/g)!.join(''),
      endereco: endereco?.trim(),
      numero: numero.trim(),
      complemento: complemento.trim(),
      bairro: bairro.trim(),
      cidade: cidade.trim(),
      estado,
      cep: cep!.match(/\d/g)!.join(''),
      titular,
      banco,
      codigo_banco,
      agencia,
      conta,
    };

    setFetching(true);

    apiSinister
      .post(`emitente/`, form)
      .then(() => {
        toast({
          title: `Emitente adicionado`,
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        setEmpresa('');
        setCnpj('');
        setEndereco('');
        setNumero('');
        setComplemento('');
        setBairro('');
        setCidade('');
        setEstado('');
        setCidade('');
        setTitular('');
        setBanco('');
        setCodigoBanco('');
        setAgencia('');
        setConta('');
        queryClient.invalidateQueries('sinistersIssuers');
        queryClient.invalidateQueries('sinistersIssuersAsSelect');
      })
      .catch(error => {
        if (error.response.status === 400) {
          const errorsValidate = Object.entries(error.response.data);
          errorsValidate.forEach(err => {
            toast({
              title: `Erro ao criar emitente`,
              description: String(err[1]),
              status: 'error',
              duration: 3000,
              isClosable: true,
              position: 'top-right',
            });
          });
        } else {
          toast({
            title: `Erro ao adicionar emitente`,
            description: 'Tente novamente',
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        }
      })
      .finally(() => {
        setFetching(false);
      });
  }

  async function handleSubmitEdit(index: number, obj: SinistersIssuers) {
    clearErrors();

    (!empresaEdit[index] || !empresaEdit[index].label.trim().length) &&
      setError(`nome-${index}`, {
        type: 'required',
        message: 'Informe o nome da empresa',
      });

    empresaEdit[index].label.length > 128 &&
      setError(`nome-${index}`, {
        type: 'maxLength',
        message: 'Nome da empresa com mais de 128 caracteres',
      });

    (!cnpjEdit[index] || !cnpjEdit[index].label.trim().length) &&
      setError(`cnpj-${index}`, {
        type: 'required',
        message: 'Informe o cnpj',
      });

    cnpjEdit[index].label.trim().length &&
      cnpjEdit[index].label.length < 14 &&
      setError(`cnpj-${index}`, {
        type: 'minLength',
        message: 'CNPJ está incorreto',
      });

    const { _formState } = control;
    if (!_formState.isValid) return;

    const cnpjFormatado = cnpjEdit[index]!.label!.match(/\d/g)!.join('');

    const form = {
      nome: empresaEdit[index].label.trim(),
      cnpj: cnpjFormatado,
      endereco: obj.endereco,
      numero: obj.numero,
      complemento: obj.complemento,
      bairro: obj.bairro,
      cidade: obj.cidade,
      estado: obj.estado,
      cep: obj.cep,
      banco: obj.banco,
      codigo_banco: obj.codigo_banco,
      agencia: obj.agencia,
      conta: obj.conta,
      titular: obj.titular,
    };

    setFetching(true);

    apiSinister
      .put(`emitente/${empresaEdit[index]?.value}/`, form)
      .then(() => {
        toast({
          title: `Empresa editada`,
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        setEmpresaEdit([...empresaEdit]);
        setCnpjEdit([...cnpjEdit]);
        handleEdit(index);
        queryClient.invalidateQueries('sinistersIssuers');
        queryClient.invalidateQueries('sinistersIssuersAsSelect');
      })
      .catch(error => {
        if (error.response.status === 400) {
          const errorsValidate = Object.entries(error.response.data);
          errorsValidate.forEach(err => {
            toast({
              title: `Erro ao editar emitente`,
              description: String(err[1]),
              status: 'error',
              duration: 3000,
              isClosable: true,
              position: 'top-right',
            });
          });
        } else {
          toast({
            title: `Erro ao editar emitente`,
            description: 'Tente novamente',
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        }
      })
      .finally(() => {
        setFetching(false);
      });
  }

  const handleEdit = (i: number, value?: SinistersIssuers) => {
    clearErrors();
    console.log('PASSEI POR AQUI');
    console.log(value);
    isEdit[i] = !isEdit[i];
    setEdit([...isEdit]);
    if (value) {
      empresaEdit[i] = { value: value.id.toString(), label: value.nome };
      setEmpresaEdit([...empresaEdit]);
      cnpjEdit[i] = { value: value.id.toString(), label: value.cnpj };
      setCnpjEdit([...cnpjEdit]);
    }
  };

  const canEdit = (index: number) => {
    return isEdit[index];
  };

  const handleEmpresa = (event: any) => {
    setEmpresa(event.target.value);
    clearErrors('empresa');
  };

  const handleCnpj = (event: any) => {
    setCnpj(event.target.value);
    clearErrors('cnpj');
  };

  const handleEndereco = (event: any) => {
    setEndereco(event.target.value);
    clearErrors('endereco');
  };

  const handleNumero = (event: any) => {
    setNumero(event.target.value);
    clearErrors('numero');
  };

  const handleComplemento = (event: any) => {
    setComplemento(event.target.value);
    clearErrors('complemento');
  };

  const handleBairro = (event: any) => {
    setBairro(event.target.value);
    clearErrors('bairro');
  };

  const handleCidade = (event: any) => {
    setCidade(event.target.value);
    clearErrors('cidade');
  };

  const handleCEP = (event: any) => {
    setCEP(event.target.value);
    clearErrors('cep');
  };

  function handleEstado(e: any) {
    setEstado(e.target.value);
    if (e.target.options.selectedIndex !== 0) {
      clearErrors('estado');
    }
  }

  const handleTitular = (event: any) => {
    setTitular(event.target.value);
    clearErrors('titular');
  };

  const handleBanco = (event: any) => {
    setBanco(event.target.value);
    clearErrors('banco');
  };

  const handleCodigoBanco = (event: any) => {
    setCodigoBanco(event.target.value);
    clearErrors('codigo_banco');
  };

  const handleAgencia = (event: any) => {
    setAgencia(event.target.value);
    clearErrors('agencia');
  };

  const handleConta = (event: any) => {
    setConta(event.target.value);
    clearErrors('conta');
  };

  const handleEmpresaEdit = (event: any, index: number, id: number) => {
    empresaEdit[index] = { value: id.toString(), label: event.target.value };
    clearErrors(`nome-${index}`);
  };

  const handleCnpjEdit = (event: any, index: number, id: number) => {
    cnpjEdit[index] = { value: id.toString(), label: event.target.value };
    clearErrors(`cnpj-${index}`);
  };
  async function handleDelete(id: number) {
    apiSinister
      .delete(`emitente/${id}/`)
      .then(() => {
        toast({
          title: `Empresa deletada`,
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        queryClient.invalidateQueries('sinistersIssuers');
        queryClient.invalidateQueries('sinistersIssuersAsSelect');
      })
      .catch(error => {
        if (error.response.status === 403) {
          toast({
            title: 'Usuário sem permissão',
            description: 'Sem permissão para execução da operação.',
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        } else {
          toast({
            title: `${error.response.data[0]}`,
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        }
      })
      .finally(() => {
        setFetching(false);
      });
  }

  return (
    <>
      <Box
        as="button"
        ref={btnRef}
        onClick={handleOpen}
        transition="all 0.2s cubic-bezier(.08,.52,.52,1)"
        border="1px"
        px="8px"
        borderRadius="4px"
        fontSize="sm"
        bg="gray.900"
        borderColor="gray.900"
        color="#fff"
        marginLeft="10px"
        h="40px"
      >
        <Flex align="center" gridGap="2">
          <Text fontSize={{ lg: 'sm', md: 'sm' }}>Novo</Text>
        </Flex>
      </Box>
      <Drawer isOpen={isOpen} placement="right" onClose={handleClose} size="lg">
        <DrawerOverlay />
        <DrawerContent borderTopLeftRadius="md">
          <DrawerCloseButton />
          <DrawerHeader>
            <Icon
              as={FiChevronLeft}
              style={{
                cursor: 'pointer',
                fontSize: '28px',
                marginRight: '10px',
              }}
              onClick={handleClose}
            />
            Cadastrar emitente
          </DrawerHeader>
          <DrawerBody>
            <Stack gridGap={6} bg="white" maxW={550} w="100%">
              <Stack gridGap={4}>
                <Heading>Adicionar</Heading>
                <FormControl isInvalid={errors?.empresa} width="70%">
                  <FormLabel htmlFor="writeUpFile" style={{ fontSize: '14px' }}>
                    Empresa *
                  </FormLabel>
                  <Input
                    name="empresa"
                    type="text"
                    error={errors.empresa}
                    fontSize="15px"
                    placeholder="Entre com o nome da empresa"
                    onChange={handleEmpresa}
                    value={empresa}
                  />
                </FormControl>
                <FormControl isInvalid={errors?.cnpj} width="50%">
                  <FormLabel htmlFor="writeUpFile" style={{ fontSize: '14px' }}>
                    CNPJ *
                  </FormLabel>
                  <Input
                    name="cnpj"
                    type="text"
                    error={errors.cnpj}
                    fontSize="15px"
                    placeholder="Entre com o CNPJ"
                    onChange={handleCnpj}
                    value={cnpj}
                    isInputMask
                    mask="99.999.999/9999-99"
                  />
                </FormControl>
                <InputGroup>
                  <FormControl isInvalid={errors?.endereco} marginRight="10px">
                    <FormLabel
                      htmlFor="writeUpFile"
                      style={{ fontSize: '14px' }}
                    >
                      Endereço *
                    </FormLabel>
                    <Input
                      name="endereco"
                      type="text"
                      error={errors.endereco}
                      fontSize="15px"
                      placeholder="Entre com o endereço"
                      onChange={handleEndereco}
                      value={endereco}
                    />
                  </FormControl>
                  <FormControl isInvalid={errors?.numero} width="40%">
                    <FormLabel
                      htmlFor="writeUpFile"
                      style={{ fontSize: '14px' }}
                    >
                      Número *
                    </FormLabel>
                    <Input
                      name="numero"
                      type="text"
                      error={errors.numero}
                      fontSize="15px"
                      placeholder="Entre com o número"
                      onChange={handleNumero}
                      value={numero}
                    />
                  </FormControl>
                </InputGroup>
                <InputGroup>
                  <FormControl
                    isInvalid={errors?.complemento}
                    marginRight="10px"
                  >
                    <FormLabel
                      htmlFor="writeUpFile"
                      style={{ fontSize: '14px' }}
                    >
                      Complemento *
                    </FormLabel>
                    <Input
                      name="complemento"
                      type="text"
                      error={errors.complemento}
                      fontSize="15px"
                      placeholder="Entre com o complemento"
                      onChange={handleComplemento}
                      value={complemento}
                    />
                  </FormControl>
                  <FormControl isInvalid={errors?.bairro} width="40%">
                    <FormLabel
                      htmlFor="writeUpFile"
                      style={{ fontSize: '14px' }}
                    >
                      Bairro *
                    </FormLabel>
                    <Input
                      name="bairro"
                      type="text"
                      error={errors.bairro}
                      fontSize="15px"
                      placeholder="Entre com o nome do bairro"
                      onChange={handleBairro}
                      value={bairro}
                    />
                  </FormControl>
                </InputGroup>
                <InputGroup>
                  <FormControl isInvalid={errors?.cidade} marginRight="10px">
                    <FormLabel
                      htmlFor="writeUpFile"
                      style={{ fontSize: '14px' }}
                    >
                      Cidade *
                    </FormLabel>
                    <Input
                      name="cidade"
                      type="text"
                      error={errors.cidade}
                      fontSize="15px"
                      placeholder="Entre com a cidade"
                      onChange={handleCidade}
                      value={cidade}
                    />
                  </FormControl>
                  <FormControl
                    isInvalid={errors?.estado}
                    marginRight="10px"
                    width="60%"
                  >
                    <FormLabel
                      htmlFor="writeUpFile"
                      style={{ fontSize: '14px' }}
                    >
                      Estado *
                    </FormLabel>
                    <Select
                      name="estado"
                      placeholder="Selecione"
                      error={errors.estado}
                      onChange={e => handleEstado(e)}
                      fontSize="15px"
                      value={estado}
                      isDisabled={isFetching}
                    >
                      {!isStatesLoading &&
                        state?.map(t => (
                          <option key={t.value} value={t.label}>
                            {t.label}
                          </option>
                        ))}
                    </Select>
                  </FormControl>
                  <FormControl isInvalid={errors?.cep} width="60%">
                    <FormLabel htmlFor="cep" style={{ fontSize: '14px' }}>
                      CEP *
                    </FormLabel>
                    <Input
                      name="cep"
                      type="text"
                      error={errors.cep}
                      margin-left="10px"
                      fontSize="15px"
                      placeholder="Entre com o CEP"
                      onChange={handleCEP}
                      value={cep}
                      isInputMask
                      mask="99999-999"
                    />
                  </FormControl>
                </InputGroup>
                <Heading>Dados bancários</Heading>
                <InputGroup>
                  <FormControl isInvalid={errors?.titular} marginRight="10px">
                    <FormLabel
                      htmlFor="writeUpFile"
                      style={{ fontSize: '14px' }}
                    >
                      Titular *
                    </FormLabel>
                    <Input
                      name="titular"
                      type="text"
                      error={errors.titular}
                      fontSize="15px"
                      placeholder="Entre com o titular"
                      onChange={handleTitular}
                      value={titular}
                    />
                  </FormControl>
                  <FormControl isInvalid={errors?.banco}>
                    <FormLabel
                      htmlFor="writeUpFile"
                      style={{ fontSize: '14px' }}
                    >
                      Banco *
                    </FormLabel>
                    <Input
                      name="titular"
                      type="text"
                      error={errors.banco}
                      fontSize="15px"
                      placeholder="Entre com o banco"
                      onChange={handleBanco}
                      value={banco}
                    />
                  </FormControl>
                </InputGroup>
                <InputGroup>
                  <FormControl
                    isInvalid={errors?.codigo_banco}
                    marginRight="10px"
                  >
                    <FormLabel
                      htmlFor="writeUpFile"
                      style={{ fontSize: '14px' }}
                    >
                      Código banco *
                    </FormLabel>
                    <Input
                      name="codigo_banco"
                      type="text"
                      error={errors.codigo_banco}
                      fontSize="15px"
                      placeholder="Entre com o código do banco"
                      onChange={handleCodigoBanco}
                      value={codigo_banco}
                    />
                  </FormControl>
                  <FormControl isInvalid={errors?.agencia} marginRight="10px">
                    <FormLabel
                      htmlFor="writeUpFile"
                      style={{ fontSize: '14px' }}
                    >
                      Agência *
                    </FormLabel>
                    <Input
                      name="agencia"
                      type="text"
                      error={errors.agencia}
                      fontSize="15px"
                      placeholder="Entre com a agência"
                      onChange={handleAgencia}
                      value={agencia}
                    />
                  </FormControl>
                  <FormControl isInvalid={errors?.conta}>
                    <FormLabel
                      htmlFor="writeUpFile"
                      style={{ fontSize: '14px' }}
                    >
                      Conta *
                    </FormLabel>
                    <Input
                      name="conta"
                      type="text"
                      error={errors.conta}
                      fontSize="15px"
                      placeholder="Entre com a conta"
                      onChange={handleConta}
                      value={conta}
                    />
                  </FormControl>
                </InputGroup>
                <Button
                  type="submit"
                  color="white"
                  background="gray.900"
                  _hover={{
                    bgColor: 'black',
                  }}
                  onClick={handleSubmit(handleCreate)}
                  width="30%"
                  height={9}
                >
                  Adicionar
                </Button>
              </Stack>
              <Heading>Emitentes cadastrados</Heading>
              <Table type="secondary" size="sm">
                <Thead>
                  <Tr>
                    <Th>Empresa</Th>
                    <Th>CNPJ</Th>
                    <Th style={{ textAlign: 'right', paddingRight: '45px' }}>
                      Ações
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {issuer &&
                    !isIssuerLoading &&
                    issuer?.map((t: any, index: number) => (
                      <Tr key={t.id}>
                        {!canEdit(index) ? (
                          <>
                            <Td>
                              <Tooltip label={t.nome} placement="top">
                                <Text isTruncated style={{ width: '190px' }}>
                                  {t.nome}
                                </Text>
                              </Tooltip>
                            </Td>
                            <Td>
                              <Tooltip label={t.cnpj_formatado} placement="top">
                                <Text isTruncated style={{ width: '190px' }}>
                                  {t.cnpj_formatado}
                                </Text>
                              </Tooltip>
                            </Td>
                            <Td
                              style={{
                                textAlign: 'right',
                                whiteSpace: 'nowrap',
                                minWidth: '120px',
                              }}
                            >
                              <Tooltip label="Editar" placement="top">
                                <IconButton
                                  w="25px"
                                  fontSize="20px"
                                  background="transparent"
                                  aria-label="Edit type"
                                  icon={<Icon as={FiEdit2} />}
                                  onClick={() => handleEdit(index, t)}
                                  marginRight="5px"
                                />
                              </Tooltip>
                              <Tooltip label="Deletar" placement="top">
                                <IconButton
                                  w="25px"
                                  fontSize="20px"
                                  background="transparent"
                                  aria-label="Remove type"
                                  icon={<Icon as={FiTrash} />}
                                  onClick={() => handleDelete(t.id)}
                                />
                              </Tooltip>
                            </Td>
                          </>
                        ) : (
                          <>
                            <Td verticalAlign="top">
                              <FormControl isInvalid={errors[`nome-${index}`]}>
                                <Input
                                  name="nome"
                                  type="text"
                                  error={errors[`nome-${index}`]}
                                  fontSize="15px"
                                  placeholder="Editar o nome da empresa"
                                  size="sm"
                                  defaultValue={empresaEdit[index].label}
                                  onChange={e =>
                                    handleEmpresaEdit(e, index, t.id)
                                  }
                                  width="190px"
                                />
                              </FormControl>
                            </Td>
                            <Td verticalAlign="top">
                              <FormControl isInvalid={errors[`cnpj-${index}`]}>
                                <Input
                                  name="cnpj"
                                  type="text"
                                  error={errors[`cnpj-${index}`]}
                                  fontSize="15px"
                                  placeholder="Editar o CNPJ da empresa"
                                  size="sm"
                                  defaultValue={cnpjEdit[index].label}
                                  onChange={e => handleCnpjEdit(e, index, t.id)}
                                  width="190px"
                                  as={InputMask}
                                  mask="99.999.999/9999-99"
                                />
                              </FormControl>
                            </Td>
                            <Td
                              style={{ textAlign: 'right' }}
                              verticalAlign="top"
                              minWidth="120px"
                            >
                              <Tooltip label="Confirmar" placement="top">
                                <IconButton
                                  w="25px"
                                  fontSize="20px"
                                  background="transparent"
                                  aria-label="Confirm"
                                  icon={<Icon as={FiCheck} />}
                                  marginRight="5px"
                                  onClick={() => handleSubmitEdit(index, t)}
                                />
                              </Tooltip>
                              <Tooltip label="Cancelar" placement="top">
                                <IconButton
                                  w="25px"
                                  fontSize="20px"
                                  background="transparent"
                                  aria-label="Cancel"
                                  icon={<Icon as={FiX} />}
                                  onClick={() => handleEdit(index)}
                                />
                              </Tooltip>
                            </Td>
                          </>
                        )}
                      </Tr>
                    ))}
                </Tbody>
              </Table>
            </Stack>
            <Button
              type="submit"
              onClick={handleClose}
              color="white"
              background="gray.900"
              _hover={{
                bgColor: 'black',
              }}
              style={{ marginTop: '20px', marginBottom: '20px' }}
            >
              Voltar
            </Button>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};
